<template>
  <div
    v-if="isVisible"
    class="subscription-block"
  >
    <div class="container">
      <div class="head">
        <h1>Скидки, акции и новинки</h1>
        <p>Подписывайтесь на Email-рассылку</p>
      </div>
      <div class="body">
        <form
          class="input"
          @submit.prevent="sendForm"
        >
          <ui-input :large="adaptive.isDesktop"
            v-model="email"
            clearable
            placeholder="Email"
            :error="!!validationError"
          />
          <div
            class="button"
          >
            <ui-button
              type="submit"
              text="Подписаться"
              :loading="progress"
              :disabled="!email || !!validationError"
              large
              wide
            />
          </div>
        </form>
        <span
          :class="{ error: validationError }"
          v-html="substring"
        />
      </div>
    </div>
  </div>
</template>

<script>
import validators from '../kit/ui-input/validators';
import { commonGtmEvents } from '@/gtm/common-gtm-events';

export default {
  name: 'subscription-block',

  inject: ['adaptive'],

  data() {
    return {
      email: '',
      error: '',
      progress: false,
      isVisible: true,
    };
  },

  computed: {
    validationError() {
      const [regex, err] = validators.email[1];
      // проверяем наполнение email, чтобы не висела ошибка по дефолту
      if (this.email && !(new RegExp(regex)).test(this.email)) {
        return err;
      }
      return '';
    },

    substring() {
      return this.validationError ? this.validationError : 'Нажимая на кнопку «Подписаться», вы принимаете <a target="_blank" href="/agreement">Условия пользовательского соглашения</a>';
    },
  },

  methods: {
    sendForm() {
      this.progress = true;
      this.$store.$api.updateSubscription({ email: this.email }).then(() => {
        this.error ? this.error = '' : null;
        this.isVisible = false;
        this.$store.dispatch('notifications/create', {
          type: 'success',
          title: 'Успешно!',
          message: 'Вы подписались на рассылку'
        });
        // Google Tag Manager event
        commonGtmEvents.successSubscribe({
          url: window.location.href,
          email: this.email,
        });
      }).catch(({ error = {} } = {}) => {
        this.error = error.detail || 'Ошибка!';
        this.$store.dispatch('notifications/create', {
          title: 'Ошибка!',
          message: 'Укажите E-mail' // пока временно хардкод, до доработок на стороне бэка
        });
      }).finally(() => {
        setTimeout(() => {
          this.progress = false;
        }, 500);
      });
    },
  },
};
</script>

<style lang="scss">
.subscription-block {
  height: 348px;
  padding: 32px 0 24px;
  background-color: $blue_l;

  .ui-input {
    min-height: initial;
  }

  .container {
    padding: 0 32px;

    .head {
      color: #fff;
      font-size: 14px;
      line-height: 20px;

      & > h1 {
        max-width: 250px;
        font-weight: bold;
        font-size: 28px;
        line-height: 40px;
        letter-spacing: 1px;
        text-transform: uppercase;
      }
    }

    .body {
      margin-top: 32px;
      font-size: 14px;
      line-height: 24px;
      color: #fff;

      .input {
        margin-top: 32px;
      }

      .button {
        margin-top: 16px;
      }

      .error {
        color: $red;
      }

      & > span {
        display: block;
        color: rgba(255,255, 255, .64);
        font-size: 12px;
        line-height: 16px;
        margin-top: 16px;

        a {
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
}

@include breakpoint("tablet") {
  .subscription-block {
    height: 164px;
    padding: 32px 0;

    .container {
      display: flex;

      .head {
        width: 50%;
        margin-right: 16px;
      }

      .body {
        width: 50%;
        margin-top: 4px;

        .input {
          display: flex;
          margin-top: 0;
        }
        .ui-input {
          flex: 1;
          &-input {
            border-radius: 4px 0 0 4px;
          }
        }

        .button {
          min-width: 118px;
          margin-top: 0;
        }

        .button > button {
          border-radius: 0 4px 4px 0;
        }

        span {
          line-height: 20px;
        }
      }
    }
  }
}

@include breakpoint("desktop") {
  .subscription-block {
    height: 176px;
    padding: 48px 0 44px;

    .container {

      .head {
        margin-right: 25px;

        & > h1 {
          max-width: 100%;
          font-size: 40px;
          line-height: 48px;
        }

        & > p {
          margin-top: 8px;
          font-size: 16px;
          line-height: 24px;
        }
      }

      .body {
        margin-top: 0;

        .input .button {
          min-width: 138px;
        }

        & > span {
          margin-top: 12px;
          line-height: 16px;
        }
      }
    }
  }
}
</style>
